/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as msRestAzure from "@azure/ms-rest-azure-js";
var packageName = "@azure/graph";
var packageVersion = "5.0.3";
var GraphRbacManagementClientContext = /** @class */ (function (_super) {
    __extends(GraphRbacManagementClientContext, _super);
    /**
     * Initializes a new instance of the GraphRbacManagementClient class.
     * @param credentials Credentials needed for the client to connect to Azure.
     * @param tenantID The tenant ID.
     * @param [options] The parameter options
     */
    function GraphRbacManagementClientContext(credentials, tenantID, options) {
        var _this = this;
        if (credentials == undefined) {
            throw new Error('\'credentials\' cannot be null.');
        }
        if (tenantID == undefined) {
            throw new Error('\'tenantID\' cannot be null.');
        }
        if (!options) {
            options = {};
        }
        if (!options.userAgent) {
            var defaultUserAgent = msRestAzure.getDefaultUserAgentValue();
            options.userAgent = packageName + "/" + packageVersion + " " + defaultUserAgent;
        }
        _this = _super.call(this, credentials, options) || this;
        _this.apiVersion = '1.6';
        _this.acceptLanguage = 'en-US';
        _this.longRunningOperationRetryTimeout = 30;
        // This is a manual patch to mitigate a bug in autorest.typescript
        // https://github.com/Azure/autorest.typescript/issues/545
        //
        // If you are regenerating this package, and you have seen a diff that removes
        // this comment or changes the following line. Please check to see if the bug
        // above has been fixed. If not, please keep this change.
        _this.baseUri = options.baseUri || "https://graph.windows.net";
        _this.requestContentType = "application/json; charset=utf-8";
        _this.credentials = credentials;
        _this.tenantID = tenantID;
        if (options.acceptLanguage !== null && options.acceptLanguage !== undefined) {
            _this.acceptLanguage = options.acceptLanguage;
        }
        if (options.longRunningOperationRetryTimeout !== null && options.longRunningOperationRetryTimeout !== undefined) {
            _this.longRunningOperationRetryTimeout = options.longRunningOperationRetryTimeout;
        }
        return _this;
    }
    return GraphRbacManagementClientContext;
}(msRestAzure.AzureServiceClient));
export { GraphRbacManagementClientContext };
//# sourceMappingURL=graphRbacManagementClientContext.js.map